export default __webpack_public_path__ + "static/media/Ilprogramma.0920ebad.jpg";